import { render, staticRenderFns } from "./confirm-evalution.vue?vue&type=template&id=0ffb4f24&"
import script from "./confirm-evalution.vue?vue&type=script&lang=js&"
export * from "./confirm-evalution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports